import * as XLSX from 'xlsx';

// Neutralise l'injection de formule: un champ texte commençant par =, +, -, @
// serait exécuté comme formule par Excel à l'ouverture du fichier.
const sanitizeCell = (value: any) =>
  typeof value === 'string' && /^[=+\-@]/.test(value) ? `'${value}` : value;

const sanitizeRows = (rows: Record<string, any>[]) =>
  rows.map((row) => Object.fromEntries(Object.entries(row).map(([key, value]) => [key, sanitizeCell(value)])));

export const exportToExcel = (filename: string, sheetName: string, rows: Record<string, any>[]) => {
  const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(rows));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, `${filename}.xlsx`);
};
